import { LeftCircleFilled, RightCircleFilled } from "@ant-design/icons";
import { Carousel as AntCarousel, CarouselProps } from "antd";
import { twMerge } from "tailwind-merge";
import Text from "./text";

const arrowClass =
  "after:!hidden !flex !h-auto !w-auto !items-center !justify-center !border-0 !bg-transparent !p-0 !opacity-100 !leading-none";

const Arrow = ({
  className,
  style,
  onClick,
  label,
  children,
}: {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler;
  label: string;
  children: React.ReactNode;
}) => {
  if (className?.includes("slick-disabled")) return null;
  return (
    <button
      type="button"
      aria-label={label}
      className={twMerge(className, arrowClass)}
      style={style}
      onClick={onClick}
    >
      <Text type="tertiary" className="!m-0 !leading-none">
        {children}
      </Text>
    </button>
  );
};

const Carousel = ({ arrows, ...props }: CarouselProps) => (
  <AntCarousel
    {...props}
    arrows={arrows}
    prevArrow={
      arrows ? (
        <Arrow label="Previous slide">
          <LeftCircleFilled style={{ fontSize: "3.2rem" }} />
        </Arrow>
      ) : undefined
    }
    nextArrow={
      arrows ? (
        <Arrow label="Next slide">
          <RightCircleFilled style={{ fontSize: "3.2rem" }} />
        </Arrow>
      ) : undefined
    }
  />
);

export default Carousel;
